export default "__VITE_ASSET__DPUWmE6B__"